import React from 'react';
import cx from 'classnames';

import { useCurrentUser } from 'src/store';
import { AppLogo, APP_LOGO_VARIANT } from 'src/components/AppLogo';
import { useIsCustomerLocked } from 'src/services';
import { SidebarItems } from './views/SidebarItems';
import { ButtonExtension } from './components/ButtonExtension';
import { WorkspaceItem } from './views/WorkspaceItem';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const NavigationSidebarPanel = ({ className }) => {
  const styles = useStyles();

  const currentUser = useCurrentUser();
  const isCustomerLocked = useIsCustomerLocked();

  const { handleExtensionItemClick } = useHandlers();

  return (
    <div
      className={cx(styles.root, className)}
      data-testid="NavigationSidebarPanel"
    >
      <div className={styles.logoWrapper}>
        <AppLogo
          className={styles.logo}
          variant={APP_LOGO_VARIANT.light}
        />
      </div>

      {!isCustomerLocked && (
        <>
          {currentUser && <WorkspaceItem className={styles.workspaceItem} />}
          <SidebarItems className={styles.items} />
          <ButtonExtension
            className={styles.buttonExtension}
            onClick={handleExtensionItemClick}
          />
        </>
      )}
    </div>
  );
};
